import { Adapter, Helper, Model } from "casbin";

export default class SerializedPermissionsAdapter implements Adapter {
  constructor(private readonly permissions: string[][]) {}

  // eslint-disable-next-line @typescript-eslint/require-await
  async loadPolicy(model: Model): Promise<void> {
    this.permissions.forEach((rule) => Helper.loadPolicyLine(rule.join(","), model));
  }

  savePolicy(): Promise<boolean> {
    throw new Error("Method not implemented.");
  }

  addPolicy(): Promise<void> {
    throw new Error("Method not implemented.");
  }

  removePolicy(): Promise<void> {
    throw new Error("Method not implemented.");
  }

  removeFilteredPolicy(): Promise<void> {
    throw new Error("Method not implemented.");
  }
}
